import React from "react";
import "./languageSwitch.css";
import { useTranslation } from "../../../Hooks/useTranslation";

const LanguageSwitch = ({ classNames = "" }) => {
  const { t, language, setLanguage } = useTranslation();
  const next = language === "es" ? "en" : "es";

  return (
    <button
      type="button"
      className={`language-switch lang-${language} ${classNames}`}
      onClick={() => setLanguage(next)}
      aria-label={t.nav.switchLanguage}
      title={t.nav.switchLanguage}
    >
      <span className="language-switch-thumb" aria-hidden="true" />
      <span className={`language-switch-option ${language === "es" ? "active" : ""}`}>ES</span>
      <span className={`language-switch-option ${language === "en" ? "active" : ""}`}>EN</span>
    </button>
  );
};

export default LanguageSwitch;
